import { useIsFocused } from "@react-navigation/native";
import { setLoginModalType } from "@redux/slices/appStateSlice";
import { useEffect } from "react";
import { View } from "react-native";
import { useDispatch, useSelector } from "react-redux";

export const ProtectedRoute = ({
  children,
  disabled = false,
}: {
  children: any;
  disabled?: boolean;
}) => {
  const isGuest = useSelector((state) => state.userInfo.isGuest);
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  useEffect(() => {
    if (isGuest && isFocused && !disabled) {
      dispatch(setLoginModalType("go-back"));
    }
  }, [isGuest, isFocused, disabled]);

  return !isGuest ? children : <View />;
};
